export default {
  namespaced: true,

  state: () => {
    const auth =
      JSON.parse(localStorage.getItem("auth")) ||
      JSON.parse(sessionStorage.getItem("auth"));

    return {
      token: auth?.token || null,
      user: auth?.user || {},
    };
  },

  mutations: {
    setUser(state, payload) {
      state.token = payload.token;
      state.user = payload.user;
      const rememberMe = payload.rememberMe ?? Boolean(localStorage.getItem("auth"));
      const storage = rememberMe ? localStorage : sessionStorage;

      localStorage.removeItem("auth");
      sessionStorage.removeItem("auth");

      storage.setItem(
        "auth",
        JSON.stringify({
          token: payload.token,
          user: payload.user,
          rememberMe,
        })
      );
    },

    clearUser(state) {
      state.token = null;
      state.user = {};

      localStorage.removeItem("auth");
      sessionStorage.removeItem("auth");
    },
  },

  getters: {
    isAuthenticated: (state) => {
      if (!state.token) return false;

      return true;
    },

    currentUser: (state) => state.user,
  },
};
